import Cookies from 'js-cookie'

const dealHead = (route, gradeEnum, courseTypeObj, subjectNameZh) => {
  const courseType = Number(route.params.courseType)
  const courseTypeNameZh = courseTypeObj ? courseTypeObj.name : ''
  const gradeNumber = Number(route.params.grade) || 0
  let grade = gradeEnum[route.params.grade].name || ''
  const subjectNum = Number(route.params.subject) || 0
  const subject = subjectNameZh[subjectNum] || ''
  const stuAreaId = Number(Cookies.get('stu_area_id'))
  if (gradeNumber === 7 && stuAreaId === 31) grade = '预初'
  let gradeRank = ''
  if (gradeNumber === 1) gradeRank = '幼儿'
  if (gradeNumber > 1 && gradeNumber < 8) gradeRank = '小学'
  if (gradeNumber > 7 && gradeNumber < 11) gradeRank = '初中'
  if (gradeNumber > 10 && gradeNumber < 14) gradeRank = '高中'
  let title = ''
  let keywords = ''
  let description = ''
  if (subjectNum === 0 && gradeNumber !== 1) {
    title = `【${
      gradeNumber === 7 ? `${stuAreaId === 31 ? '预初' : '六年级'}` : gradeRank
    }${courseTypeNameZh}】${gradeNumber > 6 ? '' : gradeRank}${grade}${
      gradeNumber > 7 ? '年级' : ''
    }在线学习课程_在线辅导_直播视频课程-学而思网校`
  }
  if (gradeNumber === 1) {
    title = `【${grade}${courseTypeNameZh}】${gradeRank}${grade}${
      subjectNum === 0 ? '' : subject
    }在线学习课程_在线辅导_直播视频课程-学而思网校`
    keywords = `学而思网校、${courseTypeNameZh}、大班${
      subjectNum === 0 ? '' : subject
    }课程、在线学习、在线辅导，直播视频课程`
    description = `【学而思网校】幼儿大班${courseTypeNameZh}教育频道为您提供幼儿大班${
      subjectNum === 0 ? '各' : subject
    }课程在线辅导与直播视频课程，${
      subjectNum === 0
        ? `包括${courseType === 4 ? '语文、' : ''}数学课程、英语作文等，`
        : ''
    }供各位家长参考。学而思网校，让学习变得更简单，更快乐，更有效!`
  }
  if (subjectNum !== 0 && gradeNumber !== 1) {
    title = `【学而思网校${courseTypeNameZh}】${
      gradeNumber > 6 ? '' : gradeRank
    }${grade}${subject}在线学习课程_在线辅导_直播视频课程-学而思网校`
  }
  if (gradeNumber !== 1) {
    keywords = `学而思网校、${
      gradeNumber === 7 && subjectNum === 0 && courseType === 3 ? '' : gradeRank
    }${courseTypeNameZh}、${grade}${
      gradeNumber > 7 && subjectNum === 0 && courseType === 4 ? '年级' : ''
    }${subjectNum === 0 ? '' : subject}课程、在线学习、在线辅导，直播视频课程`
  }
  if (gradeNumber > 1 && gradeNumber < 8) {
    description = `【学而思网校】${
      gradeNumber === 7 && subjectNum === 0 ? '' : gradeRank
    }${grade}${courseTypeNameZh}教育频道为您提供${grade}${
      subjectNum === 0 ? '各' : subject
    }课程在线辅导与直播视频课程，${
      subjectNum === 0 && courseType === 3
        ? '包括语文课程、数学课程、英语作文及编辑学习等，'
        : ''
    }${
      subjectNum === 0 && courseType === 4 ? '包括语文课程、数学课程、英语作文等，' : ''
    }${
      subjectNum === 0 && courseType === 5
        ? '包括魔方教程、儿童安全教育及围棋学习等，'
        : ''
    }供各位家长参考。学而思网校，让学习变得更简单，更快乐，更有效!`
  }
  if (gradeNumber === 8) {
    description = `【学而思网校】${gradeRank}${courseTypeNameZh}教育频道为您提供${grade}年级${
      subjectNum === 0 ? '各' : subject
    }课程在线辅导与直播视频课程，${
      subjectNum === 0 && courseType === 3
        ? `包括${grade}语文课程、数学课程、英语作文及物理课程等，`
        : ''
    }${
      subjectNum === 0 && courseType === 4
        ? `包括${grade}语文课程、数学课程、英语课程、政治课程等，`
        : ''
    }供各位家长参考。学而思网校，让学习变得更简单，更快乐，更有效!`
  }
  if (gradeNumber === 9 || gradeNumber === 10) {
    description = `【学而思网校】${gradeRank}${courseTypeNameZh}教育频道为您提供${grade}年级${
      subjectNum === 0 ? '各' : subject
    }课程在线辅导与直播视频课程，${
      subjectNum === 0 && courseType === 3
        ? `包括${grade}语文课程、数学课程、英语作文及化学课程等，`
        : ''
    }${
      subjectNum === 0 && courseType === 4
        ? `包括${grade}语文课程、数学课程、英语课程、物理课程等，`
        : ''
    }供各位家长参考。学而思网校，让学习变得更简单，更快乐，更有效!`
  }
  if (gradeNumber === 11) {
    description = `【学而思网校】${gradeRank}${courseTypeNameZh}教育频道为您提供${grade}年级${
      subjectNum === 0 ? '各' : subject
    }课程在线辅导与直播视频课程，${
      subjectNum === 0
        ? `包括${grade}语文课程、数学课程、英语${
            courseType === 3 ? '作文' : '课程'
          }、物理${courseType === 3 ? '生物' : ''}课程等，`
        : ''
    }供各位家长参考。学而思网校，让学习变得更简单，更快乐，更有效!`
  }
  if ((gradeNumber === 12 || gradeNumber === 13) && courseType === 4) {
    description = `【学而思网校】${gradeRank}${courseTypeNameZh}教育频道为您提供${grade}年级${
      subjectNum === 0 ? '各' : subject
    }课程在线辅导与直播视频课程，${
      subjectNum === 0 ? `包括${grade}语文课程、数学课程、英语课程、物理课程等，` : ''
    }供各位家长参考。学而思网校，让学习变得更简单，更快乐，更有效!`
  }
  if ((gradeNumber === 12 || gradeNumber === 13) && courseType === 3) {
    description = `【学而思网校】${gradeRank}${courseTypeNameZh}教育频道为您提供${grade}年级${
      subjectNum === 0 ? '各' : subject
    }课程在线辅导与直播视频课程，${
      subjectNum === 0 && gradeNumber === 12
        ? `包括${grade}语文课程、英语作文、生物课程及政治课程等，`
        : ''
    }${
      subjectNum === 0 && gradeNumber === 13
        ? `包括${grade}语文课程、数学课程、英语作文、化学、历史课程等，`
        : ''
    }供各位家长参考。学而思网校，让学习变得更简单，更快乐，更有效!`
  }
  return {
    title,
    keywords,
    description
  }
}

export default dealHead



// WEBPACK FOOTER //
// ./src/views/CourseCenter/util/dealHead.js